var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageLastIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 7C14.9477 7 14.4999 7.44772 14.4999 8V16C14.4999 16.5523 14.9477 17 15.4999 17C16.0522 17 16.4999 16.5523 16.4999 16V8C16.4999 7.44772 16.0522 7 15.4999 7ZM8.96674 7.24414C8.632 6.91876 8.0886 6.91878 7.75385 7.24414C7.41914 7.56949 7.41922 8.09745 7.75385 8.42285L11.4306 12L7.75092 15.5771C7.41645 15.9025 7.41634 16.4305 7.75092 16.7559C8.08562 17.0812 8.62905 17.0811 8.96381 16.7559L13.249 12.5908C13.5835 12.2655 13.5834 11.7375 13.249 11.4121L13.2519 11.4092L8.96674 7.24414Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLastIco);
export default __webpack_public_path__ + "static/media/Page_last_ico.6b9d54eb0dc9ad8b2f4fb4e3b64cef46.svg";
export { ForwardRef as ReactComponent };